export const DownloadPackageIcon = ({
  color = "#0F2C52",
}: {
  color?: string;
}) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1723_5010)">
        <path
          d="M10.0007 8.75V16.25"
          stroke={color}
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.5007 13.75L10.0007 16.25L7.50073 13.75"
          stroke={color}
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.87573 5.625H18.1257C18.1257 5.625 19.3757 5.625 19.3757 6.875V18.125C19.3757 18.125 19.3757 19.375 18.1257 19.375H1.87573C1.87573 19.375 0.625732 19.375 0.625732 18.125V6.875C0.625732 6.875 0.625732 5.625 1.87573 5.625Z"
          stroke={color}
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0.794922 6.25L2.79492 1.3675C2.89317 1.14635 3.0535 0.958468 3.25646 0.826666C3.45941 0.694865 3.69626 0.624808 3.93825 0.625H16.0633C16.3051 0.62497 16.5418 0.695102 16.7446 0.826893C16.9474 0.958685 17.1076 1.14648 17.2058 1.3675L19.1591 6.17167"
          stroke={color}
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.0007 5.625V0.625"
          stroke={color}
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1723_5010">
          <rect width="20" height="20" fill={color} />
        </clipPath>
      </defs>
    </svg>
  );
};
